module.exports = __webpack_public_path__ + "static/img/1156_phase_function_Paper_PointsHejduk_Prediction.00f8705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1156_phase_function_Paper_PointsHejduk_Prediction.png
// module id = K4w+
// module chunks = 0